(() => {
  'use strict';

  const qs = (s, root = document) => root.querySelector(s);
  const qsa = (s, root = document) => [...root.querySelectorAll(s)];

  const setCartCount = (count) => {
    qsa('[data-cart-count]').forEach(el => {
      el.textContent = count;
      el.hidden = count === 0;
    });
    qsa('[data-drawer-count]').forEach(el => { el.textContent = `(${count})`; });
  };

  const drawer = qs('[data-cart-drawer]');

  const openDrawer = () => {
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('cart-open');
  };

  const closeDrawer = () => {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('cart-open');
  };

  const refreshDrawer = async () => {
    if (!drawer) return;
    const response = await fetch(`${window.Shopify.routes.root}?section_id=cart-drawer`);
    if (!response.ok) return;
    const html = await response.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const next = doc.querySelector('[data-cart-drawer]');
    if (next) {
      drawer.innerHTML = next.innerHTML;
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('cart-open');
    }
  };

  const addToCart = async (form) => {
    const button = qs('[data-add-to-cart]', form);
    if (button) button.disabled = true;
    const data = new FormData(form);
    const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: data
    });
    if (!response.ok) {
      if (button) button.disabled = false;
      return;
    }
    const cartResponse = await fetch(`${window.Shopify.routes.root}cart.js`);
    const cart = await cartResponse.json();
    setCartCount(cart.item_count);
    await refreshDrawer();
    if (button) button.disabled = false;
  };

  document.addEventListener('click', async (event) => {
    const target = event.target.closest('[data-cart-close]');
    if (target) closeDrawer();

    const cartLink = event.target.closest('.cart-link');
    if (cartLink && drawer) {
      event.preventDefault();
      openDrawer();
    }

    const menuToggle = event.target.closest('[data-menu-toggle]');
    if (menuToggle) {
      const nav = qs('[data-mobile-nav]');
      if (!nav) return;
      const expanded = menuToggle.getAttribute('aria-expanded') === 'true';
      menuToggle.setAttribute('aria-expanded', String(!expanded));
      nav.hidden = expanded;
      document.body.classList.toggle('menu-open', !expanded);
    }

    const thumb = event.target.closest('[data-thumbnail]');
    if (thumb) {
      const index = Number(thumb.dataset.thumbnail);
      qsa('[data-product-image]').forEach((image, i) => image.classList.toggle('is-active', i === index));
      qsa('[data-thumbnail]').forEach((button, i) => button.classList.toggle('is-active', i === index));
      const images = qsa('[data-product-image]');
      if (images[index]) images[index].scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }

    const plus = event.target.closest('[data-quantity-plus]');
    const minus = event.target.closest('[data-quantity-minus]');
    if (plus || minus) {
      const control = event.target.closest('.quantity-control');
      const input = qs('input', control);
      const current = Number(input.value) || 1;
      input.value = Math.max(1, plus ? current + 1 : current - 1);
    }

    const drawerAction = event.target.closest('[data-drawer-increase], [data-drawer-decrease], [data-drawer-remove]');
    if (drawerAction) {
      const line = Number(drawerAction.dataset.line);
      const cartResponse = await fetch(`${window.Shopify.routes.root}cart.js`);
      const cart = await cartResponse.json();
      const item = cart.items[line - 1];
      if (!item) return;
      let quantity = item.quantity;
      if (drawerAction.hasAttribute('data-drawer-increase')) quantity += 1;
      if (drawerAction.hasAttribute('data-drawer-decrease')) quantity = Math.max(0, quantity - 1);
      if (drawerAction.hasAttribute('data-drawer-remove')) quantity = 0;
      const response = await fetch(`${window.Shopify.routes.root}cart/change.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line, quantity })
      });
      if (response.ok) {
        const updated = await response.json();
        setCartCount(updated.item_count);
        await refreshDrawer();
      }
    }

    const filterToggle = event.target.closest('[data-filter-toggle]');
    if (filterToggle) {
      const filters = qs('[data-filters]');
      if (!filters) return;
      filters.classList.add('is-open');
      filterToggle.setAttribute('aria-expanded', 'true');
    }

    const filterClose = event.target.closest('[data-filter-close]');
    if (filterClose) {
      const filters = qs('[data-filters]');
      if (filters) filters.classList.remove('is-open');
    }
  });

  document.addEventListener('submit', (event) => {
    const form = event.target.closest('[data-product-form]');
    if (form) {
      event.preventDefault();
      addToCart(form).catch(() => {
        form.submit();
      });
    }
  });

  const revealObserver = 'IntersectionObserver' in window
    ? new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            revealObserver.unobserve(entry.target);
          }
        });
      }, { threshold: 0.08 })
    : null;

  if (revealObserver) qsa('.reveal').forEach(el => revealObserver.observe(el));

  window.addEventListener('keydown', event => {
    if (event.key === 'Escape') {
      closeDrawer();
      const nav = qs('[data-mobile-nav]');
      const toggle = qs('[data-menu-toggle]');
      if (nav && toggle) {
        nav.hidden = true;
        toggle.setAttribute('aria-expanded', 'false');
        document.body.classList.remove('menu-open');
      }
    }
  });
})();
